export class SumupGroup {
  id: number
  school_id: number
  exec_date: string
  name: string

  constructor(sumupGroup: any){
    this.id = sumupGroup.id;
    this.school_id = sumupGroup.school_id;
    this.exec_date = sumupGroup.exec_date;
    this.name = sumupGroup.name;
  }
}

export class AverageResult {
  examinee_count: number
  allot: number
  avg_score: number
  std_dev: number
  min_score: number
  max_score: number

  constructor(averageResult: any){
    this.examinee_count = averageResult.examinee_count;
    this.allot = averageResult.allot;
    this.avg_score = averageResult.avg_score;
    this.std_dev = averageResult.std_dev;
    this.min_score = averageResult.min_score;
    this.max_score = averageResult.max_score;
  }
}

export class Part1Result {
  part1: string
  examinee_count: number
  allot: number
  avg_score: number
  std_dev: number
  min_score: number
  max_score: number
  score_rate: number

  constructor(part1Result: any){
    this.part1 = part1Result.part1;
    this.examinee_count = part1Result.examinee_count;
    this.allot = part1Result.allot;
    this.avg_score = part1Result.avg_score;
    this.std_dev = part1Result.std_dev;
    this.min_score = part1Result.min_score;
    this.max_score = part1Result.max_score;
    this.score_rate = part1Result.score_rate;
  }
}

export class ViewPointResult {
  view_point_id: number
  view_point_name: string
  examinee_count: number
  allot: number
  avg_score: number
  std_dev: number
  min_score: number
  max_score: number
  score_rate: number

  constructor(viewPointResult: any){
    this.view_point_id = viewPointResult.view_point_id;
    this.view_point_name = viewPointResult.view_point_name;
    this.examinee_count = viewPointResult.examinee_count;
    this.allot = viewPointResult.allot;
    this.avg_score = viewPointResult.avg_score;
    this.std_dev = viewPointResult.std_dev;
    this.min_score = viewPointResult.min_score;
    this.max_score = viewPointResult.max_score;
    this.score_rate = viewPointResult.score_rate;
  }
}

export class FieldResult {
  part1: string
  part2: string
  part3: string
  allot: number
  score_rate: number

  constructor(fieldResult: any){
    this.part1 = fieldResult.part1;
    this.part2 = fieldResult.part2;
    this.part3 = fieldResult.part3;
    this.allot = fieldResult.allot;
    this.score_rate = fieldResult.score_rate;
  }
}